export default __webpack_public_path__ + "static/media/eating.17241ec8.png";